import React from 'react';
import { useAuthContext } from '@contexts/AuthContext';
import { usePushAutoSubscribe } from '../hooks/usePushAutoSubscribe';
import { getAutoSubscribeConfig } from '../config/pushAutoSubscribe';
import PushPermissionModal from '../components/push/PushPermissionModal';
import Navigation from '@components/navigation/Navigation';
import MobileNavigation from '@components/navigation/MobileNavigation';
import ImpersonationBanner from '@components/admin/ImpersonationBanner/ImpersonationBanner';
import './DashboardLayout.scss';

const DashboardLayout = ({ children }) => {
    const { user } = useAuthContext();

    // Configuration pour l'auto-souscription
    const autoSubscribeConfig = getAutoSubscribeConfig(process.env.NODE_ENV);

    // Auto-souscription aux notifications push avec modale
    const {
        showPermissionModal,
        permissionLoading,
        handlePermissionAccept,
        handlePermissionDecline
    } = usePushAutoSubscribe(user, autoSubscribeConfig);

    return (
        <div className="dashboard-layout">
            <Navigation />
            <div className="dashboard-main">
                <ImpersonationBanner />
                <MobileNavigation />
                <main className="dashboard-content">
                    {children}
                </main>
            </div>

            {/* Modale de permission pour les notifications push */}
            <PushPermissionModal
                isOpen={showPermissionModal}
                onAccept={handlePermissionAccept}
                onDecline={handlePermissionDecline}
                loading={permissionLoading}
            />
        </div>
    );
};

export default DashboardLayout;